export default __webpack_public_path__ + "static/Water_Jar-3c9aaf956aca0ba9c464755177c65c8a.png";